import styled, { css } from 'styled-components'
import Color from 'color'

import { BoxProps } from 'components/styled/containers/box'
import { darkThemeGreys, lightThemeGreys } from 'theme/colors'
import { BRANDING_SMALL_FONTS } from 'app-constants'

const getHeaderShadow = (headerTextColor?: string) => {
  const headerTextShadowColor =
    headerTextColor && Color(headerTextColor).isDark()
      ? darkThemeGreys.grey60
      : lightThemeGreys.grey60

  return `-0.5px -0.5px 0 ${headerTextShadowColor},
    0.5px -0.5px 0 ${headerTextShadowColor},
    -0.5px 0.5px 0 ${headerTextShadowColor},
    0.5px 0.5px 0 ${headerTextShadowColor}
    `
}

export const getSize = (pimaryFont: string, size: number) => {
  if (BRANDING_SMALL_FONTS.includes(pimaryFont)) {
    return 1.165 * size
  }
  return size
}

export const H1Style = css`
  font-family: ${({ theme }) => theme.font.header};
  color: ${({ theme }) => theme.color.headerText};
  word-break: break-word;
  font-weight: 700;
  font-size: 6rem;
  line-height: 7.5rem;
  letter-spacing: -0.01rem;
  margin: 0;
  text-shadow: ${({ theme }) => getHeaderShadow(theme.color.headerText)};
`
export const StyledH1 = styled.h1`
  ${H1Style};
  margin-bottom: ${({ theme }) => theme.space.s16};
`

export const H2Style = css`
  font-family: ${({ theme }) => theme.font.header};
  color: ${({ theme }) => theme.color.headerText};
  word-break: break-word;
  font-weight: 700;
  font-size: 3rem;
  line-height: 4rem;
  letter-spacing: -0.03rem;
  margin: 0;

  ${({ theme }) => theme.mediaQuery.smallPhone} {
    font-size: ${({ theme }) => theme.space.s24};
    line-height: ${({ theme }) => theme.space.s32};
  }
`
export const StyledH2 = styled.h2`
  ${H2Style};
  margin-bottom: ${({ theme }) => theme.space.s16};
`

export const H3Style = css`
  font-family: ${({ theme }) => theme.font.primary};
  color: ${({ theme }) => theme.color.bodyText};
  word-break: break-word;
  font-weight: 600;
  font-size: ${({ theme }) => `${getSize(theme.font.primary, 2)}rem`};
  line-height: ${({ theme }) => `${getSize(theme.font.primary, 2.4)}rem`};;
  letter-spacing: -0.02rem;
  margin: 0;
`
export const StyledH3 = styled.h3`
  ${H3Style};
  margin-bottom: ${({ theme }) => theme.space.s8};
`

export const InfoStyle = css`
  font-family: ${({ theme }) => theme.font.primary};
  color: ${({ theme }) => theme.color.bodyText};
  word-break: break-word;
  font-weight: 400;
  font-size: ${({ theme }) => `${getSize(theme.font.primary, 2.4)}rem`};
  line-height: ${({ theme }) => `${getSize(theme.font.primary, 3.4)}rem`};
  letter-spacing: -0.01rem;
  margin: 0;
`
export const StyledInfo = styled.p`
  ${InfoStyle};
  margin-bottom: ${({ theme }) => theme.space.s8};
`

export const SubtitleStyle = css`
  font-family: ${({ theme }) => theme.font.primary};
  color: ${({ theme }) => theme.color.bodyText};
  word-break: break-word;
  font-weight: 400;
  font-size: ${({ theme }) => `${getSize(theme.font.primary, 1.6)}rem`};
  line-height: ${({ theme }) => `${getSize(theme.font.primary, 2.4)}rem`};
  margin: 0;
`
export const StyledSubtitle = styled.div`
  ${SubtitleStyle};
  margin-bottom: ${({ theme }) => theme.space.s8};
`

export const BodyStyle = css`
  font-family: ${({ theme }) => theme.font.primary};
  color: ${({ theme }) => theme.color.bodyText};
  word-break: break-word;
  font-weight: 400;
  font-size: ${({ theme }) => `${getSize(theme.font.primary, 1.4)}rem`};
  line-height: ${({ theme }) => `${getSize(theme.font.primary, 2.4)}rem`};
  margin: 0;
`
export const StyledBody = styled.p<BoxProps>`
  ${BodyStyle};
  &:not(:last-of-type) {
    margin-bottom: ${({ theme, mb }) =>
      mb ? theme.space[mb] : theme.space.s16};
  }
`

export const LabelStyle = css`
  font-family: ${({ theme }) => theme.font.primary};
  color: ${({ theme }) => theme.color.bodyText};
  word-break: break-word;
  font-weight: 600;
  font-size: ${({ theme }) => `${getSize(theme.font.primary, 1.2)}rem`};
  line-height: ${({ theme }) => `${getSize(theme.font.primary, 1.6)}rem`};
  letter-spacing: 0.1rem;
  text-transform: uppercase;
  margin: 0;
`
export const StyledLabel = styled.div`
  ${LabelStyle};
  margin-bottom: ${({ theme }) => theme.space.s8};
`

export const SmallStyle = css`
  font-family: ${({ theme }) => theme.font.primary};
  color: ${({ theme }) => theme.color.bodyText};
  word-break: break-word;
  font-weight: 400;
  font-size: ${({ theme }) => `${getSize(theme.font.primary, 1.2)}rem`};
  line-height: ${({ theme }) => `${getSize(theme.font.primary, 1.6)}rem`};
  margin: 0;
`
export const StyledSmall = styled.div<BoxProps>`
  ${SmallStyle};
  &:not(:last-child) {
    margin-bottom: ${({ theme, mb }) =>
      mb ? theme.space[mb] : theme.space.s4};
  }
`
